import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type SetDataMappingProps = ApiMethodBase & {};

export const updateLoadingStatus = ({
    eventEmitter,
}: SetDataMappingProps) => {
    eventEmitter.emit(Event.updateLoadingStatus);
};

